export * from './attachment.multiple.component';
